import React from 'react';
import type { GolfCart } from '../../types/cart.types';
import Card from '@components/ui/Card';
import Badge from '@components/ui/Badge';
import Button from '@components/ui/Button';

interface CartCardProps {
  cart: GolfCart;
  onBookClick: () => void;
}

const CartCard: React.FC<CartCardProps> = ({ cart, onBookClick }) => {
  return (
    <Card>
      <div
        className={`h-48 bg-gradient-to-br ${cart.imageGradient} rounded-t-lg flex items-center justify-center relative`}
      >
        <Badge color="green" className="absolute top-2 right-2">
          {cart.batteryType}
        </Badge>
        <img
          src={cart.imageUrl}
          alt={cart.name}
          className="h-full w-full object-contain p-4"
        />
      </div>
      <div className="p-4">
        <div className="flex justify-between items-start mb-2">
          <h3 className="font-semibold text-lg">{cart.name}</h3>
          <Badge color={cart.badge.color}>{cart.badge.text}</Badge>
        </div>
        <div className="flex items-center text-sm text-gray-500 mb-3">
          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
          </svg>
          {cart.features.join(' • ')}
        </div>
        <div className="text-center">
          <p className="text-sm text-gray-600 mb-2">{cart.pricing.label}</p>
          <span className="text-2xl font-bold text-gray-900">${cart.pricing.amount}</span>
          <span className="text-gray-500">{cart.pricing.period}</span>
        </div>
        <Button variant="primary" size="sm" onClick={onBookClick} fullWidth className="mt-3">
          Book This Cart
        </Button>
      </div>
    </Card>
  );
};

export default CartCard;